import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { doTrack } from '../../helpers/TaggingSerializer'

import './DidYouMean.scss'

class DidYouMean extends PureComponent {
  componentDidMount () {
    if (global.window) {
      doTrack('ar:storelocator:locationList:')
    }
  }
  render () {
    return (
      <div className='sc-didyoumean'>
        <h2 className='sc-didyoumean-title h2' tabIndex='0'>Did you mean</h2>
        <ol className='sc-didyoumean-results list-unstyled'>
          {
            this.props.locations.map((location, index) => {
              const coords = location.latitude + ',' + location.longitude
              return (
                <li key={index} className='sc-didyoumean-location-name'>
                  <button className='sc-didyoumean-location-btn link-btn' onClick={event => this.props.showStoresForLocation(event, location.suggestion, true, coords)} data-el={'didyoumean-link-' + index}>
                    {location.suggestion}
                  </button>
                  <noscript>
                    <a className='sc-didyoumean-location-btn' href={'/stores/?search=' + location.suggestion}>
                      {location.suggestion}
                    </a>
                  </noscript>
                </li>
              )
            })
          }
        </ol>
      </div>
    )
  }
}

DidYouMean.defaultProps = {
  locations: []
}

DidYouMean.propTypes = {
  locations: PropTypes.array,
  showStoresForLocation: PropTypes.func
}

export default DidYouMean



// WEBPACK FOOTER //
// ./src/components/DidYouMean/DidYouMean.jsx